import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketingBannerComponent } from './marketing-banner.component';
import { RouterModule } from '@angular/router';
@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [MarketingBannerComponent],
    exports: [MarketingBannerComponent],
})
export class MarketingBannerModule {}
